<template>
  <v-expansion-panel expand @change="getData()">
    <v-expansion-panel-header>
      <div class="notes-header">
        Internal Notes
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <center>
        <v-progress-circular v-if="loading" indeterminate color="blue" />
      </center>
      <v-list two-line>
        <template v-for="item in items">
          <div :key="item.id">
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon class="grey lighten-1" dark />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ formatDate(item.dateCreated) }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ item.content }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <template>
          <v-container fluid>
            <v-textarea
              v-model="newInternalNote"
              counter
              label="New Internal Note"
              :rules="rules"
            ></v-textarea>
            <v-btn color="primary" @click="save()">
              Save
            </v-btn>
          </v-container>
        </template>
      </v-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { BILLING_NAMESPACE } from "./store/billingStore";
import moment from "moment";

export default {
  name: "NotesInternal",
  props: {
    packageId: {
      type: Number,
      required: true,
      default: 0
    },
    noteType: {
      type: String,
      required: true,
      default: ""
    },
    closing: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      isOpen: false,
      items: [],
      rules: [v => (v && v.length <= 1000) || "Max 1000 characters."],
      newInternalNote: ""
    };
  },
  watch: {
    closing: function(newVal, oldVal) {
      this.items = [];
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD hh:mm");
    },
    getData() {
      if (this.items.length > 0) {
        return;
      }
      this.loading = true;
      return this.$store
        .dispatch(`${BILLING_NAMESPACE}/LOAD_NOTESINTERNAL`, {
          packageId: this.packageId,
          noteType: this.noteType
        })
        .then(data => {
          console.log(data[0].packageId)
          this.items = data;
          this.loading = false;
        });
    },
    save() {
      this.loading = true;
      return this.$store
        .dispatch(`${BILLING_NAMESPACE}/CREATE_NOTESINTERNAL`, {
          packageId: this.packageId,
          type: this.noteType,
          content: this.newInternalNote
        })
        .then(data => {
          this.items.push({
            id: data.id,
            packageId: this.packageId,
            type: this.noteType,
            content: this.newInternalNote,
            dateCreate: moment.utc()
          });
          this.newInternalNote = "";
          this.loading = false;
        });
    }
  }
};
</script>
